module.exports = __webpack_public_path__ + "img/ic-instagram-square.936f7960.svg";